import { Controller } from "stimulus"

export default class extends Controller {
  toggle(e) {
    e.preventDefault() ;
    this.element.classList.toggle('is-open') ;
    return false ;
  }
}
